import { render, staticRenderFns } from "./BillDrawer.vue?vue&type=template&id=7365c966&scoped=true"
import script from "./BillDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BillDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BillDrawer.vue?vue&type=style&index=0&id=7365c966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365c966",
  null
  
)

export default component.exports